import React, { useEffect, useState, useRef } from "react";
import CustomerNavbar from "../../../components/CustomerNavar/CustomerNavbar";
import customerimg from "../../../images/ClientDoc.svg";
import Wrapper from "../../../components/UI/Wrapper";
import search from "../../../images/SearchIcon.png";
import axios from "axios";
import CryptoJS from "crypto-js";
import "./ClientDocuments.css";
import { useLocation } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from '@mui/icons-material/Download';

const ClientDocuments = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const fileInputRef = useRef(null);

  const [firstItem, setFirstItem] = useState({
    client_doc_id: "",
    relocation_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
  });
  const [documentResponse, setDocumentResponse] = useState(null);
  const [documentType, setDocumentType] = useState([]);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetClientDocuments?relocation_id=` + Relocation_ID + `&option=1`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);          
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}userget/GetDocumentType`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setDocumentType(response.data.data.map((Name) => ({ Name })));
           
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    return file && allowedTypes.includes(file.type);
  }
  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setFirstItem({
          ...firstItem,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  function handleChange(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (isValidFileType(file)) {
        getUpdatedImage(file, name);
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      // setDecryptionError(true);

      return null;
    }
  }

  const uploadDocument = async (e) => {
    e.preventDefault();
    let updatedData = {};
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    if (firstItem !== 0) {
      updatedData = {
        ...firstItem,
        relocation_id: Relocation_ID,
      };
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/UploadClientPdfData`,
        updatedData, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setFirstItem({
        ...firstItem,
        relocation_id: "",
        document_type: "",
        remark: "",
        doc_path: "",
        doc_name: "",
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      window.location.reload();
      
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const handleDownload = async (docPath, docName) => {
    try {
      const response = await axios.get(`${docPath}`, {
        responseType: 'blob', // Important to handle binary data
      });
  
      // Create a new Blob object using the response data
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const link = document.createElement('a');
  
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', docName); // File name to save
  
      // Append link to the body and trigger click
      document.body.appendChild(link);
      link.click();
  
      // Clean up the DOM by removing the link after download
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Release the object URL after download
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('Failed to download the file.');
    }
  };

  return (
    <>
      <CustomerNavbar />

      <div className="background">
        <div className="image-container">
          <img src={customerimg} alt="img" className="customer-image" />
        </div>
      </div>

      <div>
        <div className="sscroll">
          <Wrapper className="orderlist">
            <div className="content-container-orderlist">
              <div className="container-fluid">
                <div>
                  <div className="order-summary-header">
                    <h3 className="order-summary-title">Documents Upload</h3>
                  </div>

                  <div className="table-div">
                  <div className="overflowFirstDiv">
                    <table className="orderlist">
                      <tr className="cityListHeading">
                        <th>Choose Document</th>
                        <th>Document Type</th>
                        <th>Remark</th>
                        <th>Upload Document</th>
                      </tr>

                      <tr>
                        <td>
                          <input
                            id="doc_name"
                            type="file"
                            name="doc_name"
                            onChange={handleChange}
                            ref={fileInputRef}
                            required
                            className="inputDoc1"
                            style={{padding:"0px"}}
                          />
                        </td>
                        <td>
                          <select
                            id="document_type"
                            className="form-control"
                            name="document_type"
                            onChange={handleChange}
                            value={firstItem.document_type}
                            style={{margin:"0px"}}
                          >
                            <option value="0">Select an option</option>
                            {documentType.map((item) => (
                              <option key={item}>{item.Name}</option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <input
                            id="remarkDoc"
                            type="text"
                            name="remarkDoc"
                            onChange={handleChange}
                            value={firstItem.remarkDoc}
                            className="inputDoc2"
                            style={{height:"38px"}}
                          />
                        </td>
                        <td>
                          <button
                            style={{
                              backgroundColor: "#5B489D",
                              color: "white",
                            }}
                            className="btn btn-success inputDoc3"
                            onClick={uploadDocument}
                          >
                            Upload
                          </button>
                        </td>
                      </tr>
                    </table>
                    </div>
                    <div className="overflowDiv">
                    <table className="clientDocument">
                      <thead>
                        <tr className="cityListHeading">
                          <th>Sr No.</th>
                          <th>Lead ID</th>
                          <th>Customer Name</th>
                          <th>Document Type</th>
                          <th>Remark</th>
                          <th>Lead Owner</th>
                          <th>Document</th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentResponse !== null
                          ? documentResponse.map((item, index) => (
                              <tr>
                                <td>{++index}</td>
                                <td>{item.relocation_id}</td>
                                <td>{item.CustomerName}</td>
                                <td>{item.document_type}</td>
                                <td>{item.remarkDoc}</td>
                                <td>{item.LeadOwner}</td>
                                <td>
                                  {" "}
                                  <a
                                    style={{
                                      color: "#6a6a6a",
                                      textDecoration: "none",
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                    }}
                                     href={`${baseImageURL}${item.doc_path}`} // This should point to the actual document path
                                    // // download={item.doc_name} // Forces the file to be downloaded instead of opened
                                     target="blank"
                                    // onClick={handleDownload(`${baseImageURL}${item.doc_path}`,item.doc_name)}

                                    onClick={(e) => {
    e.preventDefault();
    handleDownload(item.doc_path, item.doc_name);
  }}
                                  >
                                    Download Document <DownloadIcon />
                                  </a>
                                </td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
    </>
  );
};

export default ClientDocuments;
